import throttle from 'lodash-es/throttle'

const windowIsDefined = typeof window !== 'undefined'

class ResizeObserver {
  constructor () {
    this._callbacks = []
    this._lastScroll = windowIsDefined ? window.pageYOffset : 0

    this._handleResize = () => {
      this._callbacks.forEach( (v) => {
        const { element, fn } = v
        fn.call(element)
      })
    }

    if (windowIsDefined) {
      window.addEventListener("resize", throttle(this._handleResize), {
        passive: true
      })
    }
  }

  removeAllCallbacks (obj) {
    this._callbacks.filter((v, i, a) => {
      if (obj === v.element) {
        delete a[i]
      }
    })

    return this
  }

  removeCallback (obj, fn) {
    this._callbacks.filter((v, i, a) => {
      if (obj === v.element && fn === v.fn) {
        delete a[i]
      }
    })

    return this
  }

  addCallback (obj, fn) {
    if (typeof fn === 'function') {
      this._callbacks.push({
        element: obj,
        fn: fn
      })
    } else {
      throw new Error(`Can't add ${typeof fn} as a callback. Needs to be a 'function'`)
    }

    return this
  }
}

export default new ResizeObserver()
